import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import React from 'react';
import { GeneralMetricType, TypeMessageMap } from './types';
import DisplayValue from './DisplayValue';
import DisplayNetworkAvg from './DisplayNetworkAvg';
import DisplayTitle from './DisplayTitle';
import {
  COMMON_USAGE_MAP,
  extractGeneralMetricValue,
  getCardTypeMessageMap,
} from './helper';
import DisplayScore from './DisplayScoreChange';
import ButtonPopover from './ButtonPopover';

interface ContextWrapperProps {
  type: string;
  toplevelMetrics?: GeneralMetricType;
  displayScoreHeader?: string;
  displayScoreFooter?: string;
  displaySubtitles?: string;
  responsiveFont?: boolean;
  isTM?: boolean;
  feedbackMsgText?: string;
}

const GeneralContext: React.FC<ContextWrapperProps> = ({
  type,
  toplevelMetrics,
  displaySubtitles,
  displayScoreHeader,
  displayScoreFooter,
  responsiveFont,
}: ContextWrapperProps): React.ReactElement => {
  return (
    <Row
      spacingInset={'none none 400'}
      spacing='none'
      width='100%'
      alignmentVertical='top'
    >
      <Column
        alignmentHorizontal='start'
        spacing='none'
        minWidth={!responsiveFont ? '69px' : '130px'}
        spacingInset='none'
      >
        <Row
          spacingInset='none'
          width='100%'
          height={!responsiveFont ? '24px' : '55px'}
        >
          <DisplayValue
            metricType={type}
            metrics={toplevelMetrics!}
            responsiveFont={responsiveFont!}
          />
        </Row>
        {extractGeneralMetricValue(toplevelMetrics!, true) !== undefined && (
          <Row spacingInset='none' width='100%' height='24px' spacing='none'>
            <DisplayNetworkAvg
              metricType={type}
              metrics={toplevelMetrics!}
              networkAvgMap={COMMON_USAGE_MAP.networkAverage}
            />
          </Row>
        )}
      </Column>

      <Column spacing='none' spacingInset='none 400'>
        <Row spacingInset='none' width='100%' alignmentVertical='top'>
          <DisplayTitle
            messageMap={getCardTypeMessageMap(type)}
            displaySubtitles={displaySubtitles!}
            textSize='h200'
            maxWidth='211px'
          />
        </Row>

        <Row spacingInset='300 none none none' width='100%'>
          <DisplayScore
            metricType={type}
            metrics={toplevelMetrics!}
            messageMap={COMMON_USAGE_MAP.scoreMessage}
            displayScoreHeader={displayScoreHeader!}
            displayScoreFooter={displayScoreFooter!}
          />
        </Row>
      </Column>
      <Column alignmentHorizontal='end'>
        <ButtonPopover type={type} />
      </Column>
    </Row>
  );
};

export default GeneralContext;
